module.exports = require("./es-NI.js");